import { render, staticRenderFns } from "./SaleService.vue?vue&type=template&id=15ca1da4&scoped=true&"
import script from "./SaleService.vue?vue&type=script&lang=js&"
export * from "./SaleService.vue?vue&type=script&lang=js&"
import style0 from "./SaleService.vue?vue&type=style&index=0&id=15ca1da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca1da4",
  null
  
)

export default component.exports